<template>
  <div class="learn-container">
    <div class="heads flex-between">
      <div class="flex-row-start">
        <a href="javascript:;" class="back" @click="goBack"></a>
        <div class="heads-title">当前知识点：</div>
        <div class="heads-title-value">{{ courseInfo.knowledgeString }}</div>
      </div>
      <div class="time">计时器：{{ myHours }}:{{ myMinutes }}:{{ mySeconds }}</div>
      <div class="topic-num-box">
        第<span class="num">{{ exerciseIndex + 1 }}</span
        >题，共<span class="num">{{ exerciseList.length }}</span
        >题
      </div>
    </div>
    <div class="exercise-content-box column" v-if="isNull">
      <img src="../../assets/images/list_null.png" alt="" srcset="" />
      <div class="null">暂无数据~~</div>
    </div>
    <div class="answer-container" v-else>
      <zi-hui-xue-answer-exercise
        :exerciseList="exerciseList"
        :form="form"
        :height="styleObject"
        @submitCallBack="onSubmitCallBack"
        @nextCallBack="onNextCallBack"
      ></zi-hui-xue-answer-exercise>
    </div>
    
  </div>
</template>
<script>
import { mapActions } from "vuex";
import ZiHuiXueAnswerExercise from "../template/ZiHuiXueAnswerExercise.vue";
export default {
  components: { ZiHuiXueAnswerExercise },
  data() {
    return {
      form: {},
      courseInfo: {},
      exerciseList: [],
      exerciseIndex: 0,
      isNull: false,
      currentTime: 0,
      myHours: "00", //  小时
      myMinutes: "00", // 分钟
      mySeconds: "00", // 秒钟,
      styleObject: "500px"
    };
  },
  created() {
    this.cid = parseInt(this.$route.params.cid);
    this.getCourseInfo();
  },
  methods: {
    ...mapActions(["USER_ANSWER_SIGNIN"]),
    getCourseInfo() {
      this.onLoading();
      this.getRequest("/wenjiaoopne/kc/tongbu/getByIdCourseInfo", {
        id: this.cid,
        model_type: 2,
      })
        .then((result) => {
          this.courseInfo = result.data;
          if (result.error_code > 0) {
            return false;
          }
          this.getQuestionList(this.courseInfo.video_id);
          this.loading.close();
        })
        .catch(() => {
          this.loading.close();
        });
    },

    getQuestionList(videoId) {
      this.getRequest("/wenjiaoopne/kc/question/getVideoIdToQuestion", {
        video_id: videoId,
        question_num: 5,
      })
        .then((result) => {
          if (result.error_code != 0) {
            return false;
          }
          this.isNull = result.data.total_count < 5;
          if(result.data.total_count < 5){
            this.$message.warning("暂无本微课练习题目"); 
            return false;
          }
          this.exerciseList = result.data.list;
          this.form = {
            keys: result.data.keys,
            course_id: this.cid,
          };
          this.timer();
        })
        .catch(() => {
          this.loading.close();
        });
    },
    timer() {
      this.timeFunction();
      this.time = setInterval(() => {
        this.timeFunction();
      }, 1000);
    },
    timeFunction() {
      // 开始执行倒计时
      this.timeObj = {
        // 时间对象
        seconds: Math.floor(this.currentTime % 60),
        minutes: Math.floor(this.currentTime / 60) % 60,
        hours: Math.floor(this.currentTime / 60 / 60) % 24,
      };
      // 计算出时分秒
      this.myHours =
        this.timeObj.hours < 10 ? "0" + this.timeObj.hours : this.timeObj.hours;
      this.myMinutes =
        this.timeObj.minutes < 10
          ? "0" + this.timeObj.minutes
          : this.timeObj.minutes;
      this.mySeconds =
        this.timeObj.seconds < 10
          ? "0" + this.timeObj.seconds
          : this.timeObj.seconds;
      this.currentTime++;
    },
    goBack() {
      this.$router.push("/student/zihuixue?back=1");
    },
    onNextCallBack(index) {
      this.exerciseIndex = index;
    },
    onSubmitCallBack(result) {
      clearTimeout(this.time);
      this.USER_ANSWER_SIGNIN(result.data);
      let resultTime = `${this.myHours}:${this.myMinutes}:${this.mySeconds}`
      this.$router.push(`/student/zihuixue/learning/${this.cid}?t=${resultTime}`);
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
  beforeDestroy() {
    clearTimeout(this.time);
  }
};
</script>
<style scoped>
.learn-container {
  width: 100%;
  min-height: 700px;
  color: #7a8aa3;
  padding-bottom: 10px;
  background-color: #fff;
}
.learn-container .heads {
  width: 100%;
  height: 50px;
  background-color: #fff;
}
.learn-container .back {
  display: inline-block;
  width: 91px;
  height: 50px;
  background-image: url("../../assets/images/4.gif");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}
.learn-container .heads-title,
.heads-title-value {
  display: inline-block;
}
.learn-container .heads-title {
  margin-left: 20px;
  color: #7a8aa3;
}
.learn-container .heads-title-value {
  color: #40b8ee;
  font-size: 24px;
}
.topic-num-box {
  margin-right: 30px;
  width: 170px;
  text-align: right;
}
.learn-container .num {
  color: #40b8ee;
  margin: 0 2px;
  font-size: 25px;
}
.time {
  border-radius: 20px;
  padding: 5px 20px;
  background-color: #40b8ee;
  color: #fff;
  font-size: 14px;
}
.answer-container {
  width: 750px;
  margin: 30px auto;
}
.next-button {
  width: 302px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  margin: 0 auto;
  font-size: 20px;
  cursor: pointer;
  border-radius: 30px;
  background-color: #70e7b0;
  color: #fff;
}
</style>
